import { TMarket } from '@/common/constants/markets';
import { TAddFamilyMembersFormValues } from '@/common/containers/Dashboard/Insurance/InsuranceAddMembersPage/components/AddMemberCardForm/AddMemberCardForm.schema';
import { TMemberEligibility } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { formatDateISO } from '@/common/utils/date';
import { determineTaxIdTypeByMarket } from '@/common/utils/tax';

export const getFirstErrorIndex = (
  persons: TMemberEligibility[]
): number | null => {
  return (
    persons.findIndex((member) =>
      ['already_insured', 'tax_id_duplicated', 'already_exists'].includes(
        member.error ?? ''
      )
    ) ?? null
  );
};

export const shouldShowWarningModal = (
  persons: TMemberEligibility[]
): number | null => {
  const firstErrorIdx = getFirstErrorIndex(persons);

  const hasCriticalErrors = persons.some(
    (member) =>
      member.error === 'already_insured' || member.error === 'tax_id_duplicated'
  );

  if (
    !hasCriticalErrors &&
    firstErrorIdx !== null &&
    persons[firstErrorIdx]?.error === 'already_exists'
  ) {
    return firstErrorIdx;
  }
  return null;
};

export const convertFieldsToMenhir = (
  fields: TAddFamilyMembersFormValues['members'],
  slug: TMarket
) => {
  return fields.map((field) => ({
    type: field.type?.value ?? '',
    full_name: field.fullName,
    short_name: field.shortName,
    tax_id: {
      type: determineTaxIdTypeByMarket(slug),
      value: field.taxId,
    },
    birth_date: formatDateISO(field.birthdate),
    gender: field.gender?.value ?? '',
    error: field.error ?? null,
    selected: field.selected,
    is_user_added: field.isUserAdded,
    id: field.memberId,
    editable_fields: field.editableFields,
  }));
};
